import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import img1 from "../../../../assets/img/Services/ProductEngineering/10.jpeg";
import { FaBullseye, FaChartLine, FaMap, FaRocket, FaSearch, FaSync } from "react-icons/fa";
import { GoGraph } from "react-icons/go";

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Predictive Analytics

            </h1>
            <p className="text-lg text-gray-600">
            Harness AI to forecast trends, optimize workflows, and enhance user experiences.
						 </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaSearch className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Data-Driven Insights</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Harness AI to analyze data and extract actionable insights for growth.


               </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <GoGraph className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Trend Forecasting</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Utilize AI to predict future trends and make informed decisions.
                            </p>
            </div>

          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}